import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import SubmitButton from 'components/Widgets/SubmitButton';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate, useParams } from 'react-router-dom';

import Actions from 'components/Members/Programs/Actions';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import Alert from 'components/new_ui/Alerts/alert';

export default function Share() {
  const navigate = useNavigate();
  const { programId } = useParams();

  const [shareInitData, setShareInitData] = useState(null);

  const formSchema = Yup.object().shape({
    email: Yup.string().required('Work Email is required'),
    subject: Yup.string().required('Subject is required'),
    message: Yup.string().required('Message is required'),
  });

  useEffect(() => {
    Actions.prepareProgramShare(programId, (data) => {
      setShareInitData(data);
    }, [programId]);
  });

  const onSubmitHundler = (values, { setSubmitting }) => {
    Actions.share(
      programId,
      values,
      () => {
        setSubmitting(false);
        navigate(-1);
        Alert({
          title: 'Share Program',
          text: 'Your development plan has been successfully sent to your manager!',
        });
      },
    );
  };

  return (
    <Modal size="lg" show>
      {shareInitData === null && <LoadingPlaceholder text="Loading..." />}
      {shareInitData !== null && (
        <Formik
          validationSchema={formSchema}
          initialValues={{
            email: '',
            subject: shareInitData.subject,
            message: shareInitData.message,
          }}
          onSubmit={onSubmitHundler}
        >
          {({ isSubmitting }) => (
            <FormikForm className="needs-validation" noValidate="">
              <Row>
                <Col>
                  <HorizontalTextField
                    name="email"
                    label="E-Mail"
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <HorizontalTextField
                    name="subject"
                    label="Subject"
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <HorizontalTextField
                    name="message"
                    label="Message"
                    as="textarea"
                    required
                    rows="10"
                  />
                </Col>
              </Row>

              <footer className="footer-flex">
                <Button
                  variant="outline-primary"
                  disabled={isSubmitting}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>

                <SubmitButton loading={isSubmitting}>
                  Send
                </SubmitButton>
              </footer>

            </FormikForm>
          )}
        </Formik>
      )}

    </Modal>
  );
}
